import { render } from "./userHeader.vue?vue&type=template&id=95e9b176&ts=true"
import script from "./userHeader.vue?vue&type=script&lang=ts"
export * from "./userHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__